import { FetchNewsCommand } from './FetchNewsCommand'
import { NewDTO } from './NewDTO'
import { InMemoryNewsRepository } from '@/Infrastructure/News/InMemoryNewsRepository'
import { LanguageCode } from '@/Domain/Localization'

export class FetchNewsCommandHandler {
  private repository: InMemoryNewsRepository
  constructor (repository: InMemoryNewsRepository) {
    this.repository = repository
  }

  // eslint-disable-next-line
  async handle (command: FetchNewsCommand): Promise<NewDTO[]> {
    const newsParse: NewDTO[] = []
    const news = await this.repository.fetchAll(command.language() as LanguageCode)

    for (const n of news) {
      newsParse.push(NewDTO.fromNew(n))
    }
    return newsParse
  }
}
